
import {graphql, useStaticQuery} from 'gatsby';

const query = graphql`
query {
	renames: allAirtable(
		filter: {table: {eq: "Location Renames"}}
		sort: {rowIndex: ASC}
	) {
		nodes {
			data {
				previous: Previous
				target: Target
			}
		}
	}
}`;

type Result = {
	renames: {
		nodes: {
			data: {
				previous: string
				target: string
			}
		}[]
	}
}

export const useRemaps = (): Record<string, string> => {
	const data = useStaticQuery<Result>(query);
	return data.renames.nodes.reduce((acc, curr) => ({
		...acc,
		[curr.data.previous]: curr.data.target,
	}), {});
};
